import { FRETEBRAS_LOGOUT_URL } from '@/constants';

export const useLogout = () => () => {
  window.location.assign(FRETEBRAS_LOGOUT_URL);
};
